import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './content-section-overlay.html';
import { SidebarMenu } from '../sidebar-menu/sidebar-menu.js';
import { nuskin } from '@nuskin/ns-util'

const MENU_ITEM_CLICK = 'on-menu-item-click'
/**
 * @customElement
 * @polymer
 */
export class ContentSectionOverlay extends PolymerElement {

    ready() {
        super.ready();
        this.mySite = window.parent.document.querySelector('my-site-app');
        this.overlay = document.querySelector('my-site-preview').$.previewOverlay;
        this.mySite.addEventListener(MENU_ITEM_CLICK, this._handleMenuItemAction.bind(this));
        this.mySite.$.storefrontDrawer.addEventListener('opened-changed', this._handleDrawer.bind(this));
        this._handleMobile();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.mySite.removeEventListener(MENU_ITEM_CLICK, this._handleMenuItemAction.bind(this));
        this.mySite.$.storefrontDrawer.removeEventListener('opened-changed', this._handleDrawer.bind(this));
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'content-section-overlay';
    }

    static get properties() {
        return {
            action: {
                type: String
            },
            secondAction: {
                type: String
            },
            buttonCaption: {
                type: String,
                value:'Edit this section'
            },
            mute: {
                type: Boolean,
                observer: '_handleMute'
            },
            customPopOut: {
                type: Boolean
            },
            nonInteractive: {
                reflectToAttribute: true
            }
        };
    }

    _handleMute(newVal) {
        if(newVal)  
            this.$.wrapper.className += ' mute';
        else 
            this.$.wrapper.className = this.$.wrapper.className.split(' mute').join('');
    }

    // on initital load show mobile controls if screen is mobile
    _handleMobile() {
        this.isMobile = window.parent.window.innerWidth < this.mySite.desktopWidth;

        if(this.isMobile)
            this._handleDrawer({detail:{value: false}});
    }

    _handleDrawer(e) {
        let opened = e.detail.value;
        if(opened) {
            setTimeout(()=>{
                this.className = this.className.split(/\s?mobile/).join('');
            }, 300) // wait till css transition is over
        } else {
            if(this.className.indexOf('mobile') === -1)
                this.className += ' mobile';

            if(this.parentElement)
                this.parentElement.className = this.parentElement.className.split(/\s?pop-out/).join('');
            this.$.wrapper.className = this.$.wrapper.className.split(' mobile').join('');
            this.$.wrapper.className = this.$.wrapper.className.split(' active').join('');
            this.overlay.hide();
        }
    }

    _handleMenuItemAction(e) {
        let isMobile = window.parent.window.innerWidth < this.mySite.desktopWidth;
        if(isMobile) return;
        // if `< Back` is clicked then remove focus from content section
        if(e.detail.item === SidebarMenu.is) {
            if(this.parentElement)
                this.parentElement.className = this.parentElement.className.split(/\s?pop-out/).join('');
            this.$.wrapper.className = this.$.wrapper.className.split(' active').join('');
            this.overlay.hide();
        } else if([this.action, this.secondAction].indexOf(e.detail.item) !== -1) {
            if(!this.customPopOut && this.parentElement)
                this.parentElement.className += ' pop-out';
            this.$.wrapper.className += ' active';
            this.overlay.show();
        }
    }

    onSectionClick() {
        this.mySite.currentForm = this.action;

        this.mySite.dispatchEvent(new CustomEvent(MENU_ITEM_CLICK, {
            composed: true, 
            detail: {item: this.action}
        }));
        this.overlay.show();

        // GA
        try {
            nuskin.events.publish(nuskin.events.mySite.EDIT_SECTION_CLICK, {
                mySite: {
                    section: this.mySite.currentForm,
                    action: 'edit section button'
                }
            });
        } catch(err) {console.log(err)}
    }

    onMobileSectionClick() {
        this.mySite.currentForm = this.action;
    
        this.mySite.dispatchEvent(new CustomEvent(MENU_ITEM_CLICK, {
            composed: true, 
            detail: {
                item: this.action,
                mobile: true
            }
        }));

        // GA
        try {
            nuskin.events.publish(nuskin.events.mySite.EDIT_SECTION_CLICK, {
                mySite: {
                    section: this.mySite.currentForm,
                    action: 'edit section icon (mobile)'
                }
            });
        } catch(err) {console.log(err)}
    }
}

window.customElements.define(ContentSectionOverlay.is, ContentSectionOverlay);
